export default "__VITE_ASSET__CODs9SEk__"